import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Shopify from 'shopify-buy';

export const isTouchDevice = () => {
	try {
		document.createEvent('TouchEvent');
		return true;
	} catch (e) {
		return false;
	}
};

export const getOrientation = e => {
	if(screen.orientation){
		return screen.orientation.angle;
	}

	if(window.orientation){
		return window.orientation;
	}

	return false;
};

export const getPreviousAndNext = (total, current) => {
	let nextItem;
	let previousItem;

	if(current >= 0 && current < total - 1){
		nextItem = current + 1;
	}else{
		nextItem = 0;
	}

	if(current === 0){
		previousItem = total - 1;
	}else{
		previousItem = current - 1;
	}

	return {
		previous: previousItem,
		next: nextItem,
	}
}

export const getPhotoLabel = (artist, title, client) => {
	const ArtistNameComponent = artist.acf.hide_artist ? 'span' : Link;
	return (
		<span>
			<ArtistNameComponent
				to={{
          pathname: `/photographers/${artist.slug}`,
          state: {
            fromDetailView: true
          }
        }}
				style={{color: artist.acf.primary_color}}
				onClick={() => document.body.classList.remove('job-overview-active')} dangerouslySetInnerHTML={{__html: artist.title.rendered}}>
			</ArtistNameComponent>
			{` shoots ${title}`}
			{client &&
				` for ${client}`
			}
		</span>
	);
}

export const getVideoLabel = (artist, title, client) => {
	const ArtistNameComponent = artist.acf.hide_artist ? 'span' : Link;
	return (
		<span>
			<ArtistNameComponent
				to={{
					pathname: `/directors/${artist.slug}`,
					state: {
						fromDetailView: true
					}
				}}
				onClick={() => document.body.classList.remove('job-overview-active')}
				style={{color: artist.acf.primary_color}} dangerouslySetInnerHTML={{__html: artist.title.rendered}}>
			</ArtistNameComponent>
			{` directs ${title}`}
			{client &&
				` for ${client}`
			}
		</span>
	);
}

export const requestFullscreen = (element = document.documentElement) => {
	if(element.requestFullscreen){
		element.requestFullscreen();
	}else if(element.mozRequestFullScreen){
		element.mozRequestFullScreen();
	}else if(element.webkitEnterFullscreen){
		element.webkitEnterFullscreen();
	}else if(element.msRequestFullscreen){
		element.msRequestFullscreen();
	}
}

export const exitFullscreen = (element = document) => {
	if(element.exitFullscreen){
		element.exitFullscreen();
	}else if(element.mozCancelFullScreen){
		element.mozCancelFullScreen();
	}else if(element.webkitExitFullscreen){
		element.webkitExitFullscreen();
	}else if(element.msExitFullscreen){
		element.msExitFullscreen();
	}
}

export const getPrettyUrl = url => {
  const urlParts = /^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(url);
	return urlParts[1];
}

export const renderDuration = duration => {
	const ms = Math.floor(moment.duration(duration, 'seconds').milliseconds()).toString().substr(0,2).toString().padStart(2, 0);
	const s = moment.duration(duration, 'seconds').seconds().toString().padStart(2, 0);
	const m = moment.duration(duration, 'seconds').minutes().toString().padStart(2, 0);

	return `${m}:${s}:${ms}`;
}

export const getPrettyPrice = (price, currency = 'EUR') => {
	if(!price){
		return false;
	}

	if(price === '0.00'){
		return 'Price on Request';
	}

	if(window.innerWidth < 800){
		currency = '€';
	}

	return `${parseFloat(price).toFixed(2)} ${currency}`;
}

export const getTaxAmount = (value, taxPercentage = .19) => {
	return parseFloat(value - value / (1 + taxPercentage));
}

export const ShopifyClient = Shopify.buildClient({
	domain: shopifyDomain,
	storefrontAccessToken: storefrontAccessToken
});

export const getGraphQlCollectionId = restId => {
	return btoa(`gid://shopify/Collection/${restId}`);
}

export const getGraphQlProductId = restId => {
	return btoa(`gid://shopify/Product/${restId}`);
}

export const getGraphQlProductVariantId = restId => {
	return btoa(`gid://shopify/ProductVariant/${restId}`);
}

export const getHeaderType = () => {
	if(document.body.classList.contains('dark')){
		return 'dark';
	}
	if(document.body.classList.contains('light')){
		return 'light';
	}
	if(document.body.classList.contains('white')){
		return 'white';
	}

	return false;
}

export const truncateText = (text, limit) => {
	if (text.length > limit){
		for (let i = limit; i > 0; i--){
			if(text.charAt(i) === ' ' && (text.charAt(i-1) != ','||text.charAt(i-1) != '.'||text.charAt(i-1) != ';')) {
				return text.substring(0, i) + '...';
			}
		}
		return text.substring(0, limit) + '...';
	}else{
		return text;
	}
};
